// extracted by mini-css-extract-plugin
export var accent = "base-button-module--accent--71019";
export var brandLegacy = "base-button-module--brandLegacy--677e6";
export var button = "base-button-module--button--a09d5";
export var danger = "base-button-module--danger--0c408";
export var dangerOutline = "base-button-module--dangerOutline--13afa";
export var lg = "base-button-module--lg--78704";
export var linkButton = "base-button-module--linkButton--67088";
export var md = "base-button-module--md--2830d";
export var primary = "base-button-module--primary--69b4b";
export var primaryOutline = "base-button-module--primaryOutline--4b197";
export var secondary = "base-button-module--secondary--df21b";
export var sm = "base-button-module--sm--02283";
export var success = "base-button-module--success--7923f";
export var tertiary = "base-button-module--tertiary--de905";